export default {
  methods: {
    addCard(stripeToken) {
      return this.$store.getters['session/ajax'].post('/subscriptions/attach_source', { stripeToken }).then(resp => {
        const { records } = resp.data;
        return records;
      });
    },
    getCards() {
      return this.$store.getters['session/ajax'].get('/subscriptions/cards').then(resp => {
        const { records } = resp.data;
        return records;
      });
    },
    loadStripe() {
      const stripeURL = 'https://js.stripe.com/v3/';
      const existingScript = document.querySelector(`script[src="${stripeURL}"]`);

      if (!existingScript) {
        const stripe = document.createElement('script');
        stripe.setAttribute('src', stripeURL);
        stripe.async = true;
        document.head.appendChild(stripe);
      }
    },
    // Placeholder url and params for now
    // resumeAutoRenew() {
    //   return this.$store.getters['session/ajax'].post('/user/resume_auto_renew', params).then(resp => {
    //     return resp
    //   })
    // },
  },
};